import TrainingChart from './TrainingChart.vue'

export default TrainingChart
